import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-14 text-center px-4 text-gray-500 text-lg space-y-4"
}
const _hoisted_2 = {
  key: 1,
  class: "space-y-8"
}
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500 px-2 pt-2"
}

import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import MainViewCard from '@/components/common/MainViewCard.vue';
import GroupedWeeklyChart from '@/components/charts/GroupedWeeklyChart.vue';
import SeriesSelector from '@/components/charts/SeriesSelector.vue';
import RecordsTable from '@/components/records/RecordsTable.vue';
import { Button } from '@/components/ui/button';
import { ColumnVisibilityMenu } from '@/components/ui/data-table';
import colors from '@/plugins/tailwind';
import { useFeedDeliveriesPage } from './useFeedDeliveriesPage';

/*
 * Two tables reading an endpoint each, and a chart reading a third - see `useFeedDeliveriesPage`
 * for why the tables are kept in lock-step rather than each owning its own week selection. The
 * chart's Feed Mix selection is entirely local to it: neither table prop below reads
 * `selectedFeedMixIds`, only `series` (the chart) and `SeriesSelector` (the dropdown) do.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { approved, feedMixesLabel, isError, original, ranking, refetch, resetSelection, selectWeek, selectedFeedMixIds, selectedWeekStart, series, toggleFeedMix } = useFeedDeliveriesPage();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardContentLayout, {
    class: "space-y-8",
    heading: _ctx.$t('views.feed.deliveriesV2.header.heading'),
    "has-period-picker": true,
    "has-pig-type-picker": true
  }, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('views.pigs.records.errors.couldNotLoadData')), 1),
            _createVNode(_unref(Button), {
              variant: "outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(refetch)()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('views.pigs.records.errors.retry')), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(MainViewCard, { class: "py-4 px-2" }, {
              default: _withCtx(() => [
                _createVNode(GroupedWeeklyChart, {
                  series: _unref(series),
                  "selected-week-start": _unref(selectedWeekStart),
                  colors: _unref(colors).chart.feedDeliveries,
                  title: _ctx.$t('views.feed.deliveriesV2.chart.heading'),
                  "series-id-prefix": "feed-mix",
                  onWeekSelected: _unref(selectWeek),
                  onSelectionReset: _unref(resetSelection)
                }, {
                  "prepend-actions": _withCtx(() => [
                    _createVNode(SeriesSelector, {
                      ranking: _unref(ranking),
                      "selected-ids": _unref(selectedFeedMixIds),
                      label: _unref(feedMixesLabel),
                      onToggle: _unref(toggleFeedMix)
                    }, null, 8, ["ranking", "selected-ids", "label", "onToggle"])
                  ]),
                  _: 1
                }, 8, ["series", "selected-week-start", "colors", "title", "onWeekSelected", "onSelectionReset"]),
                (_unref(ranking).length > 5)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('views.feed.deliveriesV2.feedMixes.hiddenNote')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(MainViewCard, { class: "overflow-hidden" }, {
              default: _withCtx(() => [
                _createVNode(RecordsTable, {
                  sorting: _unref(approved).sorting,
                  "onUpdate:sorting": _cache[3] || (_cache[3] = ($event: any) => ((_unref(approved).sorting) = $event)),
                  "column-filters": _unref(approved).columnFilters,
                  "onUpdate:columnFilters": _cache[4] || (_cache[4] = ($event: any) => ((_unref(approved).columnFilters) = $event)),
                  columns: _unref(approved).columns,
                  rows: _unref(approved).visibleRows,
                  "totals-subheader": _unref(approved).totalsSubheader,
                  "facet-options": _unref(approved).facetOptions,
                  loading: _unref(approved).isFetching,
                  heading: _ctx.$t('views.feed.deliveriesV2.approved.heading'),
                  subtitle: _unref(approved).subtitle,
                  onFormActivity: _unref(approved).refreshAfterFormActivity
                }, {
                  actions: _withCtx(() => [
                    _createVNode(_unref(ColumnVisibilityMenu), {
                      options: _unref(approved).columnToggleOptions,
                      label: _ctx.$t('views.feed.deliveriesV2.approved.columnsButton'),
                      onToggle: _unref(approved).toggleColumn,
                      onSelectAll: _cache[1] || (_cache[1] = ($event: any) => (_unref(approved).setAllColumns(true))),
                      onDeselectAll: _cache[2] || (_cache[2] = ($event: any) => (_unref(approved).setAllColumns(false)))
                    }, null, 8, ["options", "label", "onToggle"])
                  ]),
                  _: 1
                }, 8, ["sorting", "column-filters", "columns", "rows", "totals-subheader", "facet-options", "loading", "heading", "subtitle", "onFormActivity"])
              ]),
              _: 1
            }),
            _createVNode(MainViewCard, { class: "overflow-hidden" }, {
              default: _withCtx(() => [
                _createVNode(RecordsTable, {
                  sorting: _unref(original).sorting,
                  "onUpdate:sorting": _cache[5] || (_cache[5] = ($event: any) => ((_unref(original).sorting) = $event)),
                  "column-filters": _unref(original).columnFilters,
                  "onUpdate:columnFilters": _cache[6] || (_cache[6] = ($event: any) => ((_unref(original).columnFilters) = $event)),
                  columns: _unref(original).columns,
                  rows: _unref(original).visibleRows,
                  "totals-subheader": _unref(original).totalsSubheader,
                  "facet-options": _unref(original).facetOptions,
                  loading: _unref(original).isFetching,
                  heading: _ctx.$t('views.feed.deliveriesV2.original.heading'),
                  subtitle: _unref(original).subtitle,
                  onFormActivity: _unref(original).refreshAfterFormActivity
                }, null, 8, ["sorting", "column-filters", "columns", "rows", "totals-subheader", "facet-options", "loading", "heading", "subtitle", "onFormActivity"])
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})